import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HasItems } from '../types';
import { BusinessVertical } from '../types/business-vertical';

@Injectable({
  providedIn: 'root',
})
export class BusinessVerticalService {
  private httpClient = inject(HttpClient);
  readonly apiHost = `${environment.apiBaseUrl}/BusinessVerticals`;

  getAllBusinessVerticals(): Observable<HasItems<BusinessVertical>> {
    return this.httpClient.get<HasItems<BusinessVertical>>(this.apiHost);
  }
}
